import { CategoryRef } from '@shared/models/category-ref';

export class DigitalCourseFilter {
  constructor() {
    this.arranger = '';
    this.available = 0;
    this.categories = '';
    this.onlyApprove = false;
    this.onlyFeatureCourse = false;
    (this.fromDate = ''), (this.toDate = '');

    this.search = '';
    this.sort = '';
    this.pageIndex = 0;
    this.pageSize = 10;
  }
  arranger: string;
  available: number;
  categories?: string;
  onlyApprove: boolean;
  onlyFeatureCourse: boolean;
  onlyPublished: boolean;
  fromDate: string;
  toDate: string;
  search: string;
  sort: string;
  pageIndex: number;
  pageSize: number;
}
